import { render, staticRenderFns } from "./adder.vue?vue&type=template&id=46f9f3a7"
import script from "./adder.vue?vue&type=script&lang=js"
export * from "./adder.vue?vue&type=script&lang=js"
import style0 from "./adder.vue?vue&type=style&index=0&id=46f9f3a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports